import React from 'react'
import AddBtn from 'components/AddBtn'
import { Grid } from '@material-ui/core'

export default function ProgramNutritionToolbar (props) {
  return (
    <div className={'tool-bar'}>
      <Grid container spacing={2}>
        <Grid container item xs={12} justifyContent={'flex-end'}>
          <AddBtn
            id='add-btn'
            color='primary'
            style={{marginRight: 0}}
            onClick={e => {
              e.stopPropagation()
              props.history.push({
                pathname: '/recipe-tags/create',
              })
            }}
            variant='contained'
          >
            Add
          </AddBtn>
        </Grid>
      </Grid>
    </div>
  )
}
